import type { SpotlightStep } from '../components/SpotlightTour.vue';

/** The Tools-list button that reopens the tour; the last step points at it. */
export const REPLAY_TOUR_BUTTON_SELECTOR = '.replay-tour-btn';

/** The days toolbar above the day list (PlanTrailRoutes.vue). */
export const DAY_TOOLBAR_SELECTOR = '.day-toolbar';

type Translate = (key: string) => string;

/**
 * The planner's multi-day spotlight tour. It launches once on its own (see
 * multiDayTutorialSeen.ts), so it closes by showing where to find it again.
 */
export function multiDayTutorialSteps(introImage: string, t: Translate): SpotlightStep[] {
  return [
    {
      title: t('plan_trail.tutorial.flags_title'),
      description: t('plan_trail.tutorial.flags_description'),
      image: introImage,
    },
    {
      selector: DAY_TOOLBAR_SELECTOR,
      title: t('plan_trail.tutorial.days_title'),
      description: t('plan_trail.tutorial.days_description'),
    },
    {
      selector: REPLAY_TOUR_BUTTON_SELECTOR,
      title: t('plan_trail.tutorial.replay_title'),
      description: t('plan_trail.tutorial.replay_description'),
      // The Actions panel may be collapsed, which takes the button off screen.
      fallbackNote: t('plan_trail.tutorial.replay_fallback'),
    },
  ];
}
